import React, { useState } from 'react';

import { useApp } from '../store/AppContext';
import { DEV_LOGIN_ENABLED, DEV_LOGIN_USERS, devLogin, TEST_LOGIN_ENABLED } from './devLogin';
import TestLoginForm from './TestLoginForm';

export default function Login({ handleMicrosoftLogin }) {
  const { loginError } = useApp();
  const [devLoginError, setDevLoginError] = useState('');
  return (
    <div className="flex items-center justify-center h-[100vh] bg-[#f5f4f2]">
      <div className="bg-white rounded-[16px] p-[32px] w-[360px] [border:0.5px_solid_#e5e3de] shadow-[0_4px_24px_rgba(0,0,0,.06)]">
        <div className="font-semibold text-[18px] mb-[4px]">Plan de charge</div>
        <div className="text-[12px] text-grey mb-[24px]">
          Uptime — Connectez-vous pour continuer
        </div>
        <button
          type="button"
          onClick={handleMicrosoftLogin}
          className="w-full flex items-center justify-center gap-[10px] py-[9px] px-[12px] rounded-[8px] [border:1px_solid_#ddd] bg-white cursor-pointer text-[13px] font-medium text-ink"
        >
          <svg width="16" height="16" viewBox="0 0 21 21" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Se connecter avec Microsoft
        </button>
        {TEST_LOGIN_ENABLED && <TestLoginForm />}
        {DEV_LOGIN_ENABLED && (
          <div className="mt-[20px] pt-[16px] [border-top:1px_dashed_#e5e3de]">
            <div className="text-[11px] font-semibold text-[#b45309] uppercase tracking-[.4px] mb-[8px]">
              Bypass login (dev local)
            </div>
            <div className="flex flex-col gap-[6px]">
              {DEV_LOGIN_USERS.map((u) => (
                <button
                  key={u.email}
                  type="button"
                  onClick={async () => setDevLoginError(await devLogin(u.email))}
                  className="w-full py-[7px] px-[10px] rounded-[8px] [border:1px_solid_#fcd34d] bg-[#fffbeb] cursor-pointer text-[12px] text-[#78350f] text-left"
                >
                  {u.label}
                </button>
              ))}
            </div>
          </div>
        )}
        {(loginError || devLoginError) && (
          <div className="text-[11px] text-[#dc2626] mt-[12px]">{loginError || devLoginError}</div>
        )}
      </div>
    </div>
  );
}
